import IconShop from "./icon-shop";

export default IconShop;